import { BoxTool } from './BoxTool'

export class EllipseTool extends BoxTool {
	constructor() {
		super({
			mode: 'ellipse',
			name: '椭圆工具',
			className: 'round',
		});
	}

	onRenderCanvas(ctx, drawing) {
		const { param, brushColor, brushWidth } = drawing;
		const [x, y, w, h] = param;
		ctx.save();
		ctx.strokeStyle = brushColor;
		ctx.lineWidth = brushWidth;

		// @see https://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas#answer-2173084
		var kappa = .5522848,
				ox = (w / 2) * kappa, // control point offset horizontal
				oy = (h / 2) * kappa, // control point offset vertical
				xe = x + w,           // x-end
				ye = y + h,           // y-end
				xm = x + w / 2,       // x-middle
				ym = y + h / 2;       // y-middle

		ctx.beginPath();
		ctx.moveTo(x, ym);
		ctx.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
		ctx.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
		ctx.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
		ctx.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
		ctx.closePath();
		ctx.stroke();

		ctx.restore();
	}
}


// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/imagePlugin/ImageEditor/tools/EllipseTool.js